import * as React from 'react';
import { StoreContext } from '../../../appContext/StoreProvider';
import { SubMenuTitle } from '../SubMenuTitle';
import { ArticlesSections } from './ArticlesSections';

export const MenuTopSections = ({ menuSync }) => {
  const { store } = React.useContext(StoreContext);
  return (
    store.hasGuides() && (
      <React.Fragment>
        <SubMenuTitle>Articles</SubMenuTitle>
        <ArticlesSections menuSync={menuSync} />
      </React.Fragment>
    )
  );
};
